import { FiCloud, FiShield, FiUser } from "react-icons/fi";
import "./Cloud.css";
import ZigZag from "./ZigZag";
import img1 from "../assests/solutions/cloud-6.jpg";
import img2 from "../assests/solutions/cloud-7.jpg";
import img3 from "../assests/solutions/cloud-4.jpg";
import img4 from "../assests/solutions/cloud-5.jpg";
import img5 from "../assests/solutions/cloud-8.jpg";
import Approach from "./Approach";
import bg from "../assests/solutions/cloud-9.jpeg"
import { useTranslation } from "react-i18next";
import cloud2 from "../assests/solutions/cloud-2.png";
// import cloud2ar from "../assests/solutions/cloud-2_ar.jpg";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
// import useAOS from "../../AosLoader";

const CloudAdaption = () => {
    // useAOS();

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title: "Understanding business requirements",
            description: "Identifying business goals and challenges",
        },
        {
            step: 2,
            title: "Assessing existing infrastructure",
            description: "Evaluating current IT infrastructure",
        },
        {
            step: 3,
            title: "Defining cloud strategy",
            description: "Developing a comprehensive cloud migration plan",
        },
        {
            step: 4,
            title: "Identifying the right cloud service model",
            description: "Determining the best model for business needs",
        },
        {
            step: 5,
            title: "Migration and validation",
            description: "Migrating databases and applications to the cloud with minimal disruption to operations and validating all migrated data.",
        },
        {
            step: 6,
            title: "Training and support",
            description: "Providing necessary training to teams and ensuring support for any issues and concerns",
        },
    ];

    return (

        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="cloud-hero"

            >
                <div className="cloud-overlay" />

                <div className="cloud-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="cloud-title">
                        Cloud Adoption
                    </h1>

                    <p className="cloud-subtitle">
                        Elevating business operations through Cloud services
                    </p>
                </div>

            </section>

            <section
                className="cloud-info-bg"
                style={{
                    backgroundImage: `url(${cloud2})`,
                }}
            >
                <div className="cloud-info-overlay" />

                <div className="cloud-info-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <p>TTH offers a comprehensive suite of cloud services designed to empower businesses to thrive in the dynamic digital landscape.</p>
                    <p>With our competitive cloud solutions, we enable organizations to enhance their agility and scalability, allowing them to maintain a competitive edge.</p>
                </div>
            </section>

            <section
                className="cloud-deployment-section"

            >
                <div className="cloud-deployment-overlay" />

                <div className="cloud-deployment-content container">
                    {/* HEADER */}
                    <p className="cloud-deployment-tag">
                        INFRASTRUCTURE | DEVELOPMENT | ANALYTICS
                    </p>

                    <h2 className="cloud-deployment-title">
                        CLOUD DEPLOYMENT
                    </h2>

                    {/* CARDS */}
                    <div className="cloud-deployment-grid">

                        {/* Managed Cloud */}
                        <div className="cloud-card" data-aos="fade-up">
                            <div className="cloud-icon-wrapper">
                                <FiCloud className="cloud-icon" />
                            </div>

                            <h3>Managed Cloud</h3>

                            <p>
                                A fully managed cloud service that hosts, monitors and maintains your
                                business applications while ensuring security, scalability and high
                                availability.
                            </p>

                            <Link to="#" className="cloud-link">
                                Learn More
                                <span>→</span>
                            </Link>
                        </div>

                        {/* Your Cloud */}
                        <div className="cloud-card" data-aos="fade-up" data-aos-delay="150">
                            <div className="cloud-icon-wrapper">
                                <FiUser className="cloud-icon" />
                            </div>

                            <h3>Your Cloud</h3>

                            <p>
                                Deploy applications in your own cloud environment while we manage the
                                infrastructure, security, access control and deployment lifecycle.
                            </p>

                            <Link to="#" className="cloud-link">
                                Learn More
                                <span>→</span>
                            </Link>
                        </div>

                        {/* Government Cloud */}
                        <div className="cloud-card" data-aos="fade-up" data-aos-delay="300">
                            <div className="cloud-icon-wrapper">
                                <FiShield className="cloud-icon" />
                            </div>

                            <h3>Government Cloud</h3>

                            <p>
                                Secure, compliant cloud deployment designed for government and regulated
                                industries with enterprise-grade security and governance.
                            </p>

                            <Link to="#" className="cloud-link">
                                Learn More
                                <span>→</span>
                            </Link>
                        </div>

                    </div>
                </div>
            </section>


            <section className="cloud-zigzag-header container" data-aos="fade-up">

                <p className="cloud-zigzag-subtitle">
                    Our array of cloud services is tailored to meet unique business requirements and elevate business operations.
                </p>

                <h2 className="cloud-zigzag-title">
                    Our services include:
                </h2>
            </section>


            <ZigZag
                title="Cloud Migration Services (CMS)"
                description="Seamlessly migrate your infrastructure and applications to the cloud with minimal disruption. Our experts ensure a secure, scalable, and cost-optimized transition tailored to your business goals."
                image={img1}
            />

            <ZigZag
                title="Cloud Integration Services (CIS)"
                description="Seamlessly integrate cloud services, applications, and data to create a unified, scalable digital ecosystem. Our Cloud Integration solutions ensure secure connectivity, optimized performance, and efficient cost management across your infrastructure."
                image={img2}
                reverse
            />

            <ZigZag
                title="Platform as a Service (PaaS)"
                description="Accelerate application development and deployment with our PaaS offerings. Our robust platform provides a ready-to-use environment, empowering teams to focus on creating innovative applications without the hassles of infrastructure management."

                image={img3}
            />

            <ZigZag
                title="Software as a Service (SaaS)"
                description="Our SaaS solutions deliver feature-rich and user-friendly applications directly from the cloud, enabling businesses to enhance productivity and collaboration across their organization."
                image={img4}
                reverse
            />

            <ZigZag
                title="Cloud Consulting and Optimization"
                description="Maximize the value of cloud investment with our expert consulting services. Our team of experienced cloud professionals help businesses assess their current infrastructure, identify optimization opportunities, and provide strategic guidance to help them make the most of the cloud."
                image={img5}
            />

            <Approach
                title="Approach"
                backgroundImage={bg}
                items={approachItems}
            />
            <Footer />
        </>
    );
};

export default CloudAdaption;
